import { render, staticRenderFns } from "./InputRadioCpt.vue?vue&type=template&id=1280c6e1&scoped=true&"
import script from "./InputRadioCpt.vue?vue&type=script&lang=ts&"
export * from "./InputRadioCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadioCpt.vue?vue&type=style&index=0&id=1280c6e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280c6e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
